import {
  BatchAvLibraryMarcRegConditionListItem,
  BatchAvLibraryMarcRegConditionListItemFromJSON
} from '@/api/models/batch/BatchAvLibraryMarcRegConditionListItem'

export interface BatchAvLibraryMarcRegPageLoadResult {
  items: BatchAvLibraryMarcRegConditionListItem
}

export function BatchAvLibraryMarcRegPageLoadResultFromJSON(
  json: any
): BatchAvLibraryMarcRegPageLoadResult {
  return {
    items: BatchAvLibraryMarcRegConditionListItemFromJSON(json)
  }
}
